import { loadImg } from './loadImg'
import * as StackBlur from 'stackblur-canvas'

export default async function (url) {
  const img = await loadImg(url)
  const canvas = document.createElement('canvas')
  canvas.height = img.height
  canvas.width = img.width
  StackBlur.image(img, canvas, 30, true)
  return canvas.toDataURL('image/png')
}
